import { render, staticRenderFns } from "./TxBox.vue?vue&type=template&id=363e9232"
import script from "./TxBox.vue?vue&type=script&lang=js"
export * from "./TxBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports